export default {
    favoriteIds() {
        return this.$store.state.session.favoriteWorkProfiles.map(profile => {return profile['@id']})
    },
    textReviewsCount() {
        return this.profile.user.ratings.filter(rating => {
            return rating.comment
        }).length
    },
    role: function() {
        return this.$store.state.session.user.roles[0]
    }
}
